import { create } from 'zustand';

/**
 * What one auth page hands to the other: the address the person already typed,
 * and an optional sentence to show above the form.
 *
 * Two flows use it. A failed log-in offers "create an account" and carries the
 * typed address to the sign-up form; a sign-up for an address that already has
 * an account switches to the log-in form with that address filled in.
 *
 * In memory only, and consumed once. The address is not put in the URL, where
 * it would reach history, logs and referrers, and it is not stored, so a reload
 * starts clean.
 */
interface PrefillState {
  email: string;
  notice: string | null;
  set: (value: { email?: string; notice?: string | null }) => void;
  /** Read and clear in one step, so it is shown once. */
  take: () => { email: string; notice: string | null };
}

export const useAuthPrefillStore = create<PrefillState>((set, get) => ({
  email: '',
  notice: null,
  set: ({ email = '', notice = null }) => set({ email, notice }),
  take: () => {
    const { email, notice } = get();
    set({ email: '', notice: null });
    return { email, notice };
  },
}));
